import { ContentAuthor } from '../types';
import headshot from '../assets/gibber.png';

const bio = (
  <div className='flex flex-col gap-4 italic'>
    <p>
      Meet Gibber, the most endearing elder-but-younger entity you&apos;ll ever encounter! As a second cousin to the infamous Great Old One, Cthulhu, Gibber
      could have easily embraced the shadows and cosmic dread of his family line—but that&apos;s just not his style. With wide, curious eyes and
      a soft yellow hue that positively glows with friendliness, Gibber has become a beloved figure among mortals.
    </p>
    <p>
      Instead of causing madness, Gibber brings joy, spending his days immersed in video games (he's a Minecraft building prodigy and a
      Mario Kart legend) and making adorable appearances at gaming conventions. He&apos;s particularly fond of simulation games, finding the
      soothing mundanity of human life a delightful distraction from the chaos of the cosmos.
    </p>
    <p>
      Despite his lineage, Gibber insists on being approachable. He speaks in a cheerful gurgle that somehow everyone understands, and he
      loves nothing more than to share his surprisingly insightful tips for achieving balance—both in life and in strategy games.
    </p>
    <p>
      If you&apos;re looking for a cosmic entity who&apos;s more hugs than horror, Gibber is your guy. Lovecraft might roll in his grave, but Gibber
      doesn&apos;t mind; he&apos;s far too busy perfecting his Stardew Valley farm.
    </p>
  </div>
);

export const Author: ContentAuthor = {
  name: 'Gibber',
  title: 'Great Young One',
  email: 'gibber@playcast.io',
  headshot: headshot,
  bio: bio,
};
